import React, { ReactNode, useContext } from "react";
import { MsTeamsContext } from "msTeams/store";
import { HostClientType } from "@microsoft/teams-js";
import { LocationIcon } from "@fluentui/react-northstar";
import { getMapsLink } from "utils/linkUtils";
import { ButtonCard } from "../buttonCard/ButtonCard";

export interface LocationCardProps {
    address: string;
    tags?: ReactNode;
}

export const LocationCard: React.FC<LocationCardProps> = (props) => {
    const msTeamsContext = useContext(MsTeamsContext);

    return (
        <ButtonCard
            textLine1={props.address}
            onClick={() => {
                window.open(
                    getMapsLink(msTeamsContext.teamsClientType === HostClientType.ios, props.address),
                    "_blank"
                );
            }}
            icon={
                <LocationIcon
                    styles={({ theme: { siteVariables } }) => ({
                        color: siteVariables.colorScheme.brand.foreground2,
                    })}
                    outline
                />
            }
            appendNodes={props.tags}
        />
    );
};
